/* eslint-disable import/prefer-default-export */
import { useMemo } from 'react';

import challengeApi from '../challenges-api';
import toLeaderboard from '../transforms/toLeaderboard';
import toChallengeDetails from '../transforms/toChallengeDetails';

export const useGetLeaderboardDetailsQuery = (
	eventId: number,
	roundId: number,
	holeNum: number
) => {
	const { data, refetch, error, ...rest } =
		challengeApi.useGetLeaderboardDetailsQuery({ eventId, roundId, holeNum });

	return {
		leaderboardDetails: useMemo(
			() => (data ? toLeaderboard(data) : undefined),
			[data]
		),
		error: error as { status: number } | undefined,
		refetchLeaderboard: refetch,
		...rest,
	};
};

// use this query to cast the data returned into the pin point challenge details object
export const usePinPointChallengeDetailsQuery = (
	eventId: number,
	roundId: number,
	holeNum: number
) => {
	const { data, refetch, ...rest } = challengeApi.useGetChallengeDetailsQuery({ eventId, roundId, holeNum }); 

	return {
		challengeDetails: useMemo(
			() => (data ? toChallengeDetails(data) : undefined),
			[data]
		),
		refetchChallengeDetails: refetch,
		...rest,
	};
};